// extracted by mini-css-extract-plugin
export default {"container":"numNotification_container__oQo4M","icon":"numNotification_icon__k72MP"};